import React, { useEffect, useState } from 'react'
import {
    Container,
    Row,
    Col,
    Card, 
    CardBody, 
    CardTitle,
    Media,
    ListGroup,
    ListGroupItem,
    Progress,
    CardHeader,
    Button,
    Table,
    Alert,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";
import { connect, useDispatch } from 'react-redux';
import { fetchCoaches, fetchCoachesReset } from "redux/ScheduleTutor/ScheduleTutorActions";
import { fetchAllUsers } from "redux/ManageUsers/ManageUsersAction";
import DataTable from "react-data-table-component";
import moment from "moment-timezone";

const AssignedStudentsPerCoach = (props) => {

    moment.tz.setDefault("America/New_York");
    const dispatch = useDispatch();

    const [coaches, setCoaches] = useState([])
    const [students, setStudents] = useState([])
    const [loading, setLoading] = useState(true);
    // const [search, setSearch] = useState("");

    useEffect(() => {
        
        dispatch(fetchCoachesReset())
        dispatch(fetchCoaches({getLoggedHoursDetails : true}));
        dispatch(fetchAllUsers({
            route: "",
            subscriptionFilter: "",
        }))
    }, [])
    
    useEffect(() => {
        setLoading(false)  
        if(props.fetchCoaches.loading){
            setLoading(true)
        }
        else if(props.fetchCoaches.fetchcoaches.length ) {

            const coachesArr = (props.fetchCoaches?.fetchcoaches?.[0] || []).sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
            setCoaches(coachesArr)
            
            
        }
        
    }, [props.fetchCoaches])
    

    useEffect(() => {   

        if (props.fetchAllUsers.allusers.length) {
            
            setStudents(props.fetchAllUsers.allusers);

            
        }
        
    }, [props.fetchAllUsers])



    const countStudentsByCoach = (coachHandle) => {
       
        return students.filter(value => value.assignedCoach == coachHandle).length
    }

    const averageGpaStudents = (coachHandle) => {
        
        const filteredStudents = students.filter(student => student.assignedCoach === coachHandle && student.cumulativeTotal != 0);

        const total = filteredStudents.reduce((sum, student) => sum + (student.cumulativeTotal || 0), 0);

        const average = filteredStudents.length > 0 ? total / filteredStudents.length : 0;

        return average;
    }



    const [nestedModal, setNestedModal] = useState(false);
    const [closeAll, setCloseAll] = useState(false);

    const toggleNested = () => {
        setNestedModal(!nestedModal);
        setCloseAll(false);
    };


    const [selectedStudents, setSelectedStudents] = useState([])

    const showLogDetails = (data) =>{
        
        // setSelectUserLogDetails(data)
        setSelectedStudents(students.filter(value => value.assignedCoach == data).sort((a, b) => (a?.name || "").localeCompare(b?.name || "")))

        setNestedModal(!nestedModal);
        
    }

    const convertDateWithTime = (date, itemFrom,itemTo) => {
            
        let localdate = convertDate(date)
        let start = convertTimeToLocal(itemFrom).format("h:mm A")
        let end = convertTimeToLocal(itemTo).format("h:mm A")
        return localdate + ", "+start+"-"+end
    }

    const convertTimeToLocal = (time) => {
        return moment(moment(time).utcOffset(0, true), "HH:mm")
    }

    const convertDate = (date) => {
        return moment(date).utcOffset(0, true).format('LL');
    }


    const columns = [
        {
            name: "",
            sortable: true,
            wrap: true,
            width: "54.5px",
            selector: (row) => {
                return <i class="fas fa-eye text-info text-lg" style={{cursor:"pointer"}} onClick={(e) => showLogDetails(row.handle)}></i>
            }
        },
        {
            name: "Primary Coach",
            sortable: true,
            width: "250px",
            sticky: true,
            selector: (row) => row.name,
            cell: (row) => {
                return <h4 className='mb-0 text-default'>{row.name}</h4>
            }
        },
        {
            name: "Students",
            sortable: true,
            width: "120px",
            selector: (row) => countStudentsByCoach(row.handle) ? countStudentsByCoach(row.handle) : 0,
            cell: (row) =>   {
                return countStudentsByCoach(row.handle) ? <h4 className='mb-0 text-default'>{countStudentsByCoach(row.handle)}</h4>  : <h3 className='mb-0'>-</h3>
            },
            
        },
        {
            name: "Last Meeting Logged",
            sortable: true,
            width: "195px",
            selector: (row) => row.lastMeetingLogged ? new Date(row.lastMeetingLogged) : "",
            cell: (row) =>   {
                return row.lastMeetingLogged ? <h4 className='mb-0 text-primary'>{row.lastMeetingLogged}</h4> : <h3 className='mb-0'>-</h3>
            },
            
        },
        {
            name: "Students Average GPA",
            sortable: "true",
            width: "210px",
            selector: (row) => averageGpaStudents(row.handle).toFixed(2) == 0 ? 0 : averageGpaStudents(row.handle).toFixed(2), 
            cell: (row) =>   {
                return averageGpaStudents(row.handle).toFixed(2) == 0 ? <h3 className='mb-0'>-</h3> : <h4 className='mb-0 text-default'>{averageGpaStudents(row.handle).toFixed(2)}</h4>
            },
            
        },
        {
            name: "Total Hours Logged Last Month",
            sortable: "true",
            width: "270px",
            selector: (row) => row.totalHoursLoggedLastMonth ? row.totalHoursLoggedLastMonth : 0,
            cell: (row) =>   {
                return row.totalHoursLoggedLastMonth ? <h4 className='mb-0 text-warning'>{row.totalHoursLoggedLastMonth}</h4> : <h4 className='mb-0'>0</h4>
            },
            
        },

        {
            name: "Total Hours Logged (YTD)",
            sortable: "true",
            width: "225px",
            selector: (row) => row.totalHoursLoggedYTD ? row.totalHoursLoggedYTD : 0,
            cell: (row) =>   {
                return row.totalHoursLoggedYTD ? <h4 className='mb-0 text-success'>{row.totalHoursLoggedYTD}</h4> : <h4 className='mb-0'>0</h4>
            },
            
        }
        // {
        //     name: "Coach",
        //     sortable: "true",
        //     center: "true",
        //     selector: (row) => {
        //         return row.mycoach ?  row.mycoach.name : "N/A";
        //     }
        // },
        // {
        //     name: "Matriculated",
        //     sortable: "true",
        //     center: "true",
        //     selector: (row) => {
        //         return  row.matriculated ? row.matriculated : 'N/A'
        //     }
        // },
        // {
        //     name: "Entry Date",
        //     sortable: "true",
        //     selector: (row) => {
        //         return convertDate(row.createdAt);
        //     }
        // },
        
    ];

    const tableHeaderstyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px",
                // backgroundColor: "#ccc",
                
            },
        },
    };
    


    
    return (
        <Card className="shadow mb-3">
            <CardHeader className="border-1">
            <Row className="align-items-center">
                <div className="col">
                    <h3 className="mb-0 text-default">Coaches Assignment Summary</h3>
                </div>
                <div className="col text-right">
                {/* <Button
                    color="primary"
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                    size="sm"
                >
                    See all
                </Button> */}
                </div>
            </Row>
            </CardHeader>
            
            <CardBody>
                    { 
											
                        loading ? 
                            <div className="m-5">
                                <Alert color="secondary" className="text-center">
                                    Collecting data.. Please wait while loading {" "}
                                    <Spinner size="sm" color="primary" />{" "}
                                </Alert>
                            </div>
                        : coaches.length ? 
                                <DataTable

                                   
                                    progressPending={loading}
                                    paginationRowsPerPageOptions={[5,10,30,50,100]}
                                    customStyles={tableHeaderstyle}
                                    columns={columns}
                                    data={coaches}
                                    pagination
                                    wrap
                                    // selectableRows
                                    // fixedHeader
                                    selectableRowsHighlight
                                    highlightOnHover
                                    // subHeader
                                    // subHeaderComponent={
                                    // <input
                                    //     type="text"
                                    //     className="w-50 form-control"
                                    //     placeholder="Search..."
                                    //     value={search}
                                    //     onChange={(e) => setSearch(e.target.value)}
                                    // />
                                    // }
                                    // subHeaderAlign="right"
                                />
                        : 
                        <div className="m-5">
                            <Alert color="primary">No data available .</Alert>
                        </div>
                    
                    
                    }
            </CardBody>

            

            <Modal
                isOpen={nestedModal}
                toggle={toggleNested}
                
                // size="xl"
                centered
            >
                <ModalHeader toggle={toggleNested}>
               
                </ModalHeader>
                <ModalBody className="pt-1" >
                    <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <Table hover responsive>
                            <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                                <tr>
                                    <th>Student</th>
                                    <th>Last Session with Coach</th>
                                </tr>
                            </thead>
                            <tbody>
       
                                {selectedStudents.map((val) => {
                                    return <tr>
                                        <td>{val.name}</td>
                                        <td>{val.latestLogHour ?  <span className='mb-0 font-weight-bold text-primary'>{convertDateWithTime(val.latestLogHour.date, val.latestLogHour.startTime, val.latestLogHour.endTime)}</span>: <h3 className='mb-0'>-</h3>}</td>
                                    </tr>
                                })}
                                    
                            
                            </tbody>
                        </Table>
                    </div>
                    
                </ModalBody>
                
            </Modal>
        </Card>
    )
}

const mapStateToProps = (state) => {
    return {
      fetchAllUsers: state.fetchAllUsers,
      fetchCoaches: state.fetchCoaches
    };
};
  
export default connect(mapStateToProps)(AssignedStudentsPerCoach);